<div class="flex flex-col items-end">
  <div 
  *ngFor="let c of threads; trackBy: trackByCommentId"
  [ngStyle]="{ 'margin-left': (level * 16) + 'px' }"
  class="relative group w-full "
>
  <div *ngIf="level > 0" class="absolute -left-4 top-0 bottom-0 w-px bg-slate-200"></div>

  <div class="bg-white border border-slate-200 rounded-lg shadow-sm hover:border-slate-300 transition-all mb-3 overflow-hidden">
    
    <div class="flex items-center justify-between px-4 py-2 bg-slate-50/50 border-b border-slate-100 text-[11px]">
      <div class="flex items-center gap-3">
        <span *ngIf="c.is_main" class="px-1.5 py-0.5 rounded bg-blue-600 text-white font-bold uppercase text-[9px] tracking-wider">
          Comment Remark
        </span>
        <span *ngIf="c.has_approved" class="px-1.5 py-0.5 rounded bg-blue-600 text-white font-bold uppercase text-[9px] tracking-wider">
          Approval Remark
        </span>
        <span *ngIf="c.has_rejected" class="px-1.5 py-0.5 rounded bg-blue-600 text-white font-bold uppercase text-[9px] tracking-wider">
          Rejection Remark
        </span>
        
        <span class="text-slate-400">|</span>

        <span *ngIf="c.created_on || c.created_at" class="text-slate-500 font-medium italic">
          {{ (c.created_on || c.created_at) | date:'dd MMM yyyy • hh:mm a' }}
        </span>
      </div>

      <div class="flex items-center gap-1.5 text-slate-500">
        <i class="fa-solid fa-user-tie text-[10px] opacity-50"></i>
        <span class="font-semibold text-slate-700">{{ userDisplayName(c.created_by) }}</span>
      </div>
    </div>

    <div class="px-4 py-3">
      <div *ngIf="c.comment" class="text-slate-700 text-[13.5px] leading-relaxed">
        <div [innerHTML]="safeHtml(c.comment)" class="prose prose-sm max-w-none prose-slate"></div>
      </div>

      <div *ngIf="c?.created_by" class="flex justify-end mt-4">
        <div class="flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-md p-1 pr-3 hover:bg-white transition-colors cursor-default">
          
          <div class="relative bg-white p-1 rounded border border-slate-100 shadow-inner">
            <qrcode
              [qrdata]="getQrPayload(c.created_by)"
              [width]="40"
              [errorCorrectionLevel]="'M'"
              [margin]="0"
              [style.width.px]="40"
              [style.height.px]="40"
            ></qrcode>
          </div>

          <div class="flex flex-col">
            <div class="flex items-center gap-1">
              <i class="fa-solid fa-certificate text-blue-500 text-[8px]"></i>
              <span class="text-[9px] font-bold text-slate-400 uppercase tracking-widest">Digitally Verified</span>
            </div>
            
            <p class="text-[11px] font-bold text-slate-800 leading-none mt-0.5">
              {{ c?.created_by?.rankCode }} {{ c?.created_by?.first_name }} {{ c?.created_by?.last_name }}
            </p>
            
            <p class="text-[10px] text-slate-500 mt-1 opacity-80 leading-none">
               {{ c?.created_by?.hrcdf_designation || '-' }} 
               <span class="mx-1">•</span> 
               {{ c?.created_by?.unit?.name || '-' }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-comment-thread
    *ngIf="c.replies?.length"
    [threads]="c.replies || []"
    [level]="level + 1"
  ></app-comment-thread>
</div>
</div>